export function envDomainSuffix(url: string) {
  return url;
}
export function messageScript(): { url: string, integrity: string, msgEnv: string } {
  return {
    url: 'https://assets.graphisoft.com/scripts/gsMessage/gsMessage.js',
    integrity: 'sha384-5qB2tTbm4OLvyCuRSNahJXJP2H3YFeCoUIuZxbtZhjfJ4D9J378h800ndRldWj53',
    msgEnv: 'production',
  };
}

export function getOneTrustLink() {
  return 'https://privacyportal-de.onetrust.com/ui/#/preferences/multipage/token/be7df656-c2d2-4d51-a205-99b7bab43dcf';
}
